import styled, { css } from 'styled-components';

import { atMinWidth } from '../../../atoms/breakpoints';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  order: 2;
  position: relative;
  z-index: 10;

  ${({ reverse }) =>
    reverse &&
    css`
      ${atMinWidth.xl`
        order: 1;
      `}
    `}

  ${({ layout, reverse }) =>
    layout === 'full-width' &&
    css`
      justify-content: ${reverse ? 'flex-end' : 'flex-start'};
      .gatsby-image-wrapper,
      .gatsby-image-wrapper img {
        ${atMinWidth.xl`
          max-height: 686px;
          object-position: ${reverse ? 'right' : 'left'};
        `}
      }
    `}
  .responsive-img {
    max-width: 100%;
    height: 100%;
  }

  ${({ isGif, reference }) =>
    isGif &&
    css`
      .gatsby-image-wrapper {
        width: 100% !important;
        aspect-ratio: ${reference?.image?.width} / ${reference?.image?.height} !important;
      }
      img {
        object-fit: contain !important;
        width: 100% !important;
        height: 100% !important;
      }
    `}
`;
